import * as React from "react"

export function OptionalBadge() {
  return (
    <span className="text-xs text-stone-400 dark:text-stone-500 font-normal ml-2">
      Optional
    </span>
  )
}
